import React, { useEffect } from "react";
import "./LanguageSelect.css";
import { languages } from "./language-data";

function LanguageSelect(props) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  const handleClickLanguage = (languageIndex) => {
    props.setLanguageIndex(languageIndex);
  };

  const handleClickSelect = () => {
    props.setIsOpen(false);
    document.body.style.overflow = "initial";
  };

  const selectInputs = languages.map((item, i) => {
    return (
      <div
        onClick={(e) => handleClickLanguage(i)}
        key={i}
        className="item-wrapper"
      >
        <div
          className="radio-area"
          style={{
            borderColor: props.languageIndex === i ? "#0194FF" : "#999999",
          }}
        >
          <div
            className="radio-area-inside"
            style={{
              opacity: props.languageIndex === i ? "1" : 0,
            }}
          ></div>
        </div>
        {item}
      </div>
    );
  });
  return (
    <div
      style={{
        opacity: props.isOpen ? 1 : 0,
        pointerEvents: props.isOpen ? "all" : "none",
      }}
      className="language-main-wrapper"
    >
      <div className="select-language-title">Select Language</div>
      <div>{selectInputs}</div>
      <div className="language-select-wrapper">
        <div onClick={handleClickSelect} className="language-select-button">
          SELECT
        </div>
      </div>
    </div>
  );
}

export default LanguageSelect;
